import { ReactNode, useEffect } from "react";
import { useLocation } from "wouter";
import { usePlan } from "@/lib/plan";
import { reportNoActionsLeft } from "@/lib/outOfActions";

// Guards the pre-generation steps of the create flow (identify, blueprint,
// review blueprint): a Free user with no AI actions left can't finish a test,
// so don't let them start one. Sends them to the dashboard with the upgrade
// dialog open. Deliberately NOT used on /create/generate or later steps: the
// server gates generation itself, and a run that spends the last action must
// not bounce the user off their own results.
export function RequireAiActions({ children }: { children: ReactNode }) {
  const { isOutOfActions, limit, resetsAt } = usePlan();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!isOutOfActions) return;
    reportNoActionsLeft(limit, resetsAt);
    setLocation("/dashboard");
    // resetsAt is a fresh Date every render; depend on its value.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOutOfActions, limit, resetsAt.getTime(), setLocation]);

  return isOutOfActions ? null : <>{children}</>;
}
